import { BannerNotificationTargetType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const bannerNotificationTargetTypeName: { [key in BannerNotificationTargetType]: TKeyType } = {
  [BannerNotificationTargetType.USER]: 'common.player',
  [BannerNotificationTargetType.AGENT]: 'common.agent'
}

export default bannerNotificationTargetTypeName
